<template>

    <FloatingPanel title="Formulier" :width="400">

        <div class="common-canvas-blocks-modules-form-BlockPanel">

            <Tabs :tabs="[
                'Formulier',
                'Algemeen',
            ]">

                <div slot="Formulier">

                    <div class="tw-m-5">

                        <div class="tw-mb-1 tw-text-gray-600 label">Welk formulier?</div>

                        <small class="tw-block tw-mb-3 tw-text-gray-500 label tw-text-muted">Kies hier het formulier wat
                            getoond dient te gaan worden.</small>

                        <v-select
                            :options="forms"
                            label="name"
                            v-model="options.form_id"
                            :reduce="form => form.id">
                            <div slot="no-options">Geen opties</div>
                        </v-select>

                    </div>

                    <div class="tw-m-5">

                        <div class="tw-mb-1 tw-text-gray-600 label">Wat is de titel?</div>
                        <input
                            type="text"
                            class="focus:tw-border-blue-300 focus:tw-outline-none focus:tw-shadow-outline-blue form-control form-input sm:tw-leading-5 sm:tw-text-sm tw-border tw-border-gray-300 tw-border-solid tw-duration-150 tw-ease-in-out tw-mt-1 tw-px-3 tw-py-2 tw-rounded-md tw-shadow-sm tw-transition tw-w-full"
                            @input="$set(options, 'title', $event.target.value)"
                            :value="options.title"/>

                    </div>

                    <div class="tw-m-5">

                        <div class="tw-mb-1 tw-text-gray-600 label">Wat is de tekst?</div>
                        <textarea
                            type="text"
                            class="focus:tw-border-blue-300 focus:tw-outline-none focus:tw-shadow-outline-blue form-control form-input sm:tw-leading-5 sm:tw-text-sm tw-border tw-border-gray-300 tw-border-solid tw-duration-150 tw-ease-in-out tw-mt-1 tw-px-3 tw-py-2 tw-rounded-md tw-shadow-sm tw-transition tw-w-full"
                            @input="$set(options, 'text', $event.target.value)"
                            :value="options.text"></textarea>

                    </div>

                </div>

                <div slot="Algemeen">

                    <CommonInputs
                        :options="options"/>

                </div>

            </Tabs>

        </div>

    </FloatingPanel>

</template>

<script>

import axios from '@galaxy/js/common/AxiosBuilder';
import Tabs from "@galaxy/js/common/canvas/editor/canvas/document/editors/panels/Tabs";
import AbstractPanel from "@galaxy/js/common/canvas/editor/canvas/document/editors/AbstractPanel";
import FloatingPanel from "@galaxy/js/common/canvas/editor/canvas/document/editors/panels/FloatingPanel";
import CommonInputs from "@galaxy/components/common/canvas/editors/CommonInputs";

export default {

    extends: AbstractPanel,

    components: {
        FloatingPanel,
        CommonInputs,
        Tabs,
    },

    data() {
        return {
            forms: [],
        };
    },

    created() {
        this.loadForms();
    },

    methods: {

        async loadForms() {
            // Load artists.
            this.forms = (await axios.get(this.adminUrlPrefix + '/forms')).data;
        },

        setTitle() {
            // TODO Validate
            // Set
            this.$set(this.options, 'title', $(this.$refs['title']).val());
        },

        setText() {
            // TODO Validate
            // Set
            this.$set(this.options, 'text', $(this.$refs['text']).val());
        },

    },

}

</script>

<style lang="scss">

.common-canvas-blocks-modules-form-BlockPanel {
    .vs--open {
        .vs__dropdown-toggle {
            @apply tw-rounded-none tw-rounded-t-md;
        }

        .vs__search {
            @apply tw-border tw-border-gray-300 tw-border-solid tw-duration-150 tw-ease-in-out tw-mt-1 tw-px-3 tw-py-2 tw-rounded-md tw-shadow-sm tw-transition tw-w-full;

            &:focus {
                @apply tw-border-blue-300 tw-outline-none;
            }
        }
    }

    .vs__dropdown-toggle {
        @apply tw-border tw-border-gray-300 tw-border-solid tw-duration-150 tw-ease-in-out tw-mt-1 tw-px-2 tw-py-1 tw-rounded-md tw-shadow-sm tw-transition tw-w-full;
        min-height: 38px;

        &:focus {
            @apply tw-border-blue-300 tw-outline-none;
        }
    }

    .vs__search {
        @apply tw-hidden;
    }
}

</style>
